import config from "../../../config"; // Pages

import ApartmentsPage from "./apartments";
import ApartmentsBuilding from "./building";
export var Routes = [{
  path: "".concat(config.routes.get("apartments"), "/:buildingSlug"),
  component: ApartmentsBuilding,
  exact: !0
}];
export * from "./apartments";